import Loader from '@anm/components/Loader';
import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter, media, stretchBlock } from '@anm/styles/helpers';
import styled from 'styled-components';

import { ImageProps } from './types';

export const IMAGE_TOP_OFFSET = 0;

export const LoaderWrapper = styled(Loader)`
  z-index: 3;
  position: absolute;
`;

export const Preview = styled.img<{ isAbsolute: boolean }>`
  ${stretchBlock};
  z-index: 1;
  bottom: 4px;
  height: unset;
  position: ${({ isAbsolute }) => (isAbsolute ? 'absolute' : 'static')};
`;

export const Video = styled.video`
  z-index: 2;
  position: relative;
`;

export const ImageOverlay = styled.div<ImageProps>`
  ${stretchBlock};
  z-index: 3;
  bottom: 4px;
  opacity: 0.65;
  top: -${IMAGE_TOP_OFFSET}px;
  background-color: #292a2b;
  height: ${({ height }) => height}px;
`;

export const ImagePlaceholder = styled.div<ImageProps>`
  width: 100%;
  position: relative;
  margin-right: auto;
  min-height: ${({ height }) => height}px;
  background: url(${getFromCdn('images/dashboard/default_preview.svg')}) no-repeat center/80px #ebeef5;
`;

export const PreviewWrapper = styled.div<{ minHeigh: number }>`
  ${flexCenter};
  position: relative;
  min-height: ${({ minHeigh }) => minHeigh}px;
  video,
  img {
    width: 100%;
    max-width: 100%;
  }
  img {
    top: -${IMAGE_TOP_OFFSET}px;
  }
`;

const engagementContentOnMobile = media.phone`
  margin: 0;
`;

export const EngagementContent = styled.div`
  margin-right: 48px;
  ${engagementContentOnMobile};
  @media (max-height: 415px) and(orientation: landscape) {
    margin: 0;
  }
`;

export const InfoMessage = styled.p`
  top: 50%;
  z-index: 5;
  color: #fff;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
  font-size: 16px;
  max-width: 259px;
  position: absolute;
  text-align: center;
  transform: translateY(-50%);
  a {
    color: inherit;
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const EngagementChartWrapper = styled.div`
  ${stretchBlock};
  z-index: 4;
  .tooltip {
    * > {
      width: 100%;
      text-align: center;
    }
    div {
      p:first-child {
        font-weight: bold;
      }
      p {
        margin: 0;
        text-align: center;
        font-weight: normal;
      }
    }
  }
  .label {
    opacity: 1;
    bottom: -20px;
    color: #919eaa;
    font-size: 14px;
    position: absolute;
  }
  .vertical-line,
  .tooltip {
    font-size: 14px;
    position: absolute;
    pointer-events: none;
  }
  .axis-grid .tick:nth-child(7) text {
    transform: translate(6px, 6px);
  }
  .vertical-line {
    width: 1px;
    opacity: 0;
    background: #fff;
  }
`;
